// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2639":"06cb5b82","3522":"763e5ead","4078":"72218b77","6528":"06cb5b82","8092":"06cb5b82","8678":"57a9b2c2","9184":"546e6921","9335":"546e6921"}[chunkId] + ".chunk.css";
};